"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _Stepper = _interopRequireDefault(require("@material-ui/core/Stepper"));
var _Step = _interopRequireDefault(require("@material-ui/core/Step"));
var _StepLabel = _interopRequireDefault(require("@material-ui/core/StepLabel"));
var _StepButton = _interopRequireDefault(require("@material-ui/core/StepButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '100%'
    },
    backButton: {
      marginRight: theme.spacing(1)
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  };
});
function SttStepper(props) {
  var steps = props.steps,
    activeStep = props.activeStep;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_Stepper["default"], {
    activeStep: activeStep,
    alternativeLabel: true
  }, steps.map(function (label) {
    return /*#__PURE__*/_react["default"].createElement(_Step["default"], {
      key: label
    }, /*#__PURE__*/_react["default"].createElement(_StepLabel["default"], null, label));
  })));
}
var _default = SttStepper;
exports["default"] = _default;